<template>
    <main class="main" id="main">
        <div class="top_line">
            <div class="container work_box">
                <h1 class="work">РАБОТАТЬ С НАМИ - КРУТО!</h1>
                <p>ХОЧУ ПОЕСТЬ - это кардинально новый подход в области сервисов по заказу и доставке еды в интернете</p>
            </div>
        </div>

        <!----------Section feed------------->

        <section class="section s-feed">
            <div class="container">
                <h1>НАША ЦЕЛЬ - НАКОРМИТЬ ВСЕХ И КАЖДОГО!</h1>
                <div class="points_box">
                    <div class="point_item">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/map.svg">
                        <p class="left">Не важно, где Вы живёте: в огромном мегаполисе или маленьком городке</p >
                    </div>
                    <div class="point_item">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/bracket_right.svg">
                        <p class="middle">Не важно, где Вы живёте: в огромном мегаполисе или маленьком городке</p>
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/bracket_left.svg">
                    </div>
                    <div class="point_item">
                        <p class="right">Не важно, где Вы живёте: в огромном мегаполисе или маленьком городке</p>
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/net.svg">
                    </div>
                    <h2>Готов быть первым? Тогда присоединяйся!</h2>
                </div>

                <div class="team_box">
                    <h1>МЫ НАБИРАЕМ В КОМАНДУ ТЕХ</h1>
                    <div class="requierments">
                        <div class="require_item">
                            <p><span>кто</span> любит много учиться и достигать вершин;</p>
                        </div>
                        <div class="require_item">
                            <p><span>кто</span> на все 100% уверен в своих силах;</p>
                        </div>
                        <div class="require_item">
                            <p><span>кто</span> мечтает о большем;</p>
                        </div>
                        <div class="require_item">
                            <p><span>кто</span> живёт в ногу со временем;</p>
                        </div>
                        <div class="require_item">
                            <p><span>кто</span> будет неравнодушен к общему делу;</p>
                        </div>
                        <div class="require_item">
                            <p><span>кто</span> способен мыслить открыто и креативно;</p>
                        </div>
                        <div class="require_item full">
                            <p>Уже сегодня мы запускаемся в твоём городе и нам нужен именно ТЫ - активный и
                                целеустремлённый, чувствующий новые веяния родного города, и самое главное -
                                готовый развиваться и развивать других.</p>
                        </div>
                    </div>
                </div>
            </div>

        </section>

        <div class="bottom_line">
            <img class="bg" src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/franchise/bottom_line.png" alt="">
            <div class="container">
                <div class="contacts_box">
                    <div class="text">
                        <p>Присылайте нам на почту свои истории, связанные с доставкой еды.</p>
                        <p>Самые интересные мы опубликуем, и конечно же сделаем вкусный подарок!</p>
                    </div>
                    <div class="send_box">
                        <span>hr@hochu-poest.com</span>
                        <button class="menu_item_btn green">НАПИСАТЬ</button>
                    </div>
                </div>
            </div>
        </div>
    </main>

</template>

<script>
export default {
  name: 'work'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/articles/work.vue